import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-8"
};
import { onMounted } from 'vue';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import VoucherList from './elements/VoucherList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VouchersSearchPage',
    setup(__props) {
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getAvailableVouchers, getCustomerVouchers, removeUnavailableDiscountProviders, removeCustomerFavouriteDiscount, addCustomerFavouriteDiscount } = useVouchers();
        function onLoad() {
            getCustomer();
            getAvailableVouchers(() => {
                state.availableVouchers.forEach((v) => {
                    removeUnavailableDiscountProviders(v);
                });
            });
            getCustomerVouchers();
        }
        function favouriteToggled(voucher) {
            if (voucher.favourite) {
                removeCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
            else {
                addCustomerFavouriteDiscount(voucher, () => {
                    voucher.favourite = !voucher.favourite;
                });
            }
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Search retail cards",
                    border: _ctx.image ? 0 : null,
                    bgcolor: _ctx.image ? '#00000000' : 'white',
                    color: _ctx.image ? 'white' : null
                }, null, 8, ["border", "bgcolor", "color"]),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).availableVouchers && _unref(state).vouchers,
                    cardBlocks: !_ctx.filter
                }, null, 8, ["customer", "cardBlocks"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).availableVouchers)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(VoucherList, {
                                    showFavourites: true,
                                    onFavouriteToggled: _cache[0] || (_cache[0] = (v) => { favouriteToggled(v); }),
                                    showAll: true,
                                    vouchers: _unref(state).availableVouchers,
                                    search: true
                                }, null, 8, ["vouchers"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _cache[1] || (_cache[1] = _createElementVNode("div", { style: { "clear": "both" } }, null, -1))
            ], 64));
        };
    }
});
